import { uniq } from 'lodash'
import { Page } from '../../../models/util.model'
import { StocksListingKeys } from '../models/stock-listing.model'
import { Stock } from '../models/stock.entity'

export function parseStockPageKeys(page: Page<Stock>) {
  return page.data.reduce<StocksListingKeys>(
    (acc, r) => parseStockKeys(r, acc),
    {},
  )
}

/**
 * Parse stocks external data
 * @param stock - the stock
 * @param extData - the external data object
 * @returns the extData updated
 */
export function parseStockKeys(
  stock: Stock,
  extData: StocksListingKeys = {},
): StocksListingKeys {
  const warehouseIds = uniq(
    stock.warehouse?._id
      ? [...(extData['warehouseIds'] || []), stock.warehouse!._id]
      : [...(extData['warehouseIds'] || [])],
  )
  return {
    warehouseIds,
  }
}
